import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { getSharesTransferLabels } from 'modules/transactions/utils/getSharesTransferLabels';

import { useHistoryMovementsView } from '../../context/HistoryMovementsViewContext';

const SharesTransferTableHeader: FC = () => {
  const { t } = useTranslate();

  const { data } = useHistoryMovementsView();

  const modalLabels = getSharesTransferLabels(data?.operationType || '');

  return (
    <thead className="tb-head">
      <tr>
        <th className="text-left">{t(modalLabels.transmittingPartner)}</th>
        <th className="text-left">{t(modalLabels.recipientPartner)}</th>
        <th className="text-left">{t('Class')}</th>
        <th className="text-center">{t('Price')}</th>
        <th className="text-center">{t('From')}</th>
        <th className="text-center">{t('To')}</th>
      </tr>
    </thead>
  );
};

export default SharesTransferTableHeader;
